import { StyledComponentProps, withStyles } from "@material-ui/core";
import {
	Timeline,
	TimelineConnector,
	TimelineConnectorProps,
	TimelineContent,
	TimelineContentProps,
	TimelineDot,
	TimelineDotProps,
	TimelineItem,
	TimelineItemProps,
	TimelineProps,
	TimelineSeparator,
	TimelineSeparatorProps,
} from "@material-ui/lab";
import { Maybe } from "graphql/jsutils/Maybe";
import { salad, swamp } from "../hooks/use-map-theme-styles";
import componentStyles from "./component-styles";

interface LyfeTimelineProps {
	timelineProps?: Maybe<TimelineProps>;
	connectorColor?: string;
	items: Array<{
		child: JSX.Element;
		timelineItemProps?: Pick<TimelineItemProps, "style" | "children" | "innerRef" | "className" | "ref"> &
			StyledComponentProps<"missingOppositeContent">;
		timelineSeparatorProps?: Maybe<TimelineSeparatorProps>;
		timelineDotProps?: Maybe<TimelineDotProps>;
		timelineDotColors?: Maybe<[string, string]>;
		timelineConnectorProps?: Maybe<TimelineConnectorProps>;
		timelineContentProps?: Maybe<TimelineContentProps>;
	}>;
}

const LyfeTimeline: React.FC<LyfeTimelineProps> = ({ timelineProps, items, connectorColor }) => {
	const { mtN1, mbN2 } = componentStyles({});

	return (
		<Timeline style={{ marginLeft: "-15px" }} {...timelineProps}>
			{items.map((item, i) => (
				<LyfeTimelineItem key={i} {...item.timelineItemProps}>
					<TimelineSeparator
						style={{
							paddingRight: item.timelineDotProps?.children ? 0 : "9px",
						}}
						{...item.timelineSeparatorProps}
					>
						<TimelineDot
							style={{
								backgroundColor: item.timelineDotColors?.length ? item.timelineDotColors[0] : salad,
								marginTop: "12px",
								marginLeft: !item.timelineDotProps?.children ? "9px" : undefined,
								borderColor: item.timelineDotColors?.length ? item.timelineDotColors[1] : swamp,
								borderStyle: item.timelineDotProps?.children ? "none" : "solid",
								padding: item.timelineDotProps?.children ? 0 : "4px",
								...item.timelineDotProps?.style,
							}}
						>
							{item.timelineDotProps?.children}
						</TimelineDot>
						<TimelineConnector
							classes={{ root: `${mtN1} ${mbN2}` }}
							style={{
								backgroundColor: connectorColor || swamp,
								marginLeft: !item.timelineDotProps?.children ? "9px" : undefined,
								...item.timelineConnectorProps?.style,
							}}
							{...item.timelineConnectorProps}
						/>
					</TimelineSeparator>
					<TimelineContent {...item.timelineContentProps}>{item.child}</TimelineContent>
				</LyfeTimelineItem>
			))}
		</Timeline>
	);
};

export default LyfeTimeline;

const LyfeTimelineItem = withStyles({
	missingOppositeContent: {
		"&:before": {
			display: "none",
		},
	},
})(TimelineItem);
